// @flow
import SimpleDate from 'app/dataProviders/SimpleDate';

// Заполняет массив дней недели датами в соответствии с реальной неделей,
// определяемой по одной дате из этой недели
// 6-ти дневная неделя

type Week = Array<string>
const emptyWeek: Week = ['', '', '', '', '', ''];

export default function fillWeekFromDay(day: SimpleDate, format: string): Week {
  if (day.getIsValid()) {
    const momentDay = day.createMoment();
    const mDay = !momentDay.day() ? momentDay.day(-1) : momentDay;
    const week = emptyWeek.map((item, i): string => mDay.day(i + 1).format(format));
    return week;
  }
  return emptyWeek;
}
